import React, { Component } from 'react';
import { object } from 'prop-types';
import { Box, DialogContent } from '@mui/material';
import Loading from 'components/common/Loading';

class DialogPicture extends Component {
  state = {
    src: null,
  };

  componentDidMount() {
    const { file } = this.props;
    const reader = new FileReader();
    reader.onload = e => {
      this.setState({ src: e.target.result });
    };
    reader.readAsDataURL(file);
  }

  render() {
    const { src } = this.state;
    return (
      <DialogContent>
        <Box sx={{ minWidth: 300, minHeight: 200, textAlign: 'center' }}>
          {!src ? (
            <Loading />
          ) : (
            <Box component="img" alt="modal" src={src} sx={{ maxWidth: '50%', maxHeight: '50%' }} />
          )}
        </Box>
      </DialogContent>
    );
  }
}

DialogPicture.propTypes = {
  file: object.isRequired,
};

export default DialogPicture;
